import { AbstractFormatter } from '../Formatter';
import { TypedValue } from '../DataPrimitive';
import { DataPoint } from '../DataPoint';
import EncodingExecutor from '../EncodingExecutor';

/**
 * Math function to divide.
 *
 * ```js
 * <SampleViz
 *     context={{
 *         divisor: '> majorValue | subtract(trendValue)'
 *         trendValuePercent: '> trendValue | divideBy(divisor)'
 *     }}
 * />
 * ```
 */
export class DivideBy extends AbstractFormatter<'number', 'number'> {
    private readonly divisor: number;

    constructor(divisor: any) {
        super();
        this.divisor = EncodingExecutor.rawTree(divisor);
    }

    protected formatTypedValue(p: DataPoint<'number'>): TypedValue<'number'> {
        const { value } = p.getValue();
        const dividedValue = this.divisor !== 0 && value / this.divisor;
        return { value: dividedValue, type: 'number' };
    }
}
